import { Alert, AlertDescription, Button } from '@design-system';
import { QuestionnaireDialog } from '@/features/client-quick-plan';

import { ClipboardCheck } from 'lucide-react';

import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectClient } from '@/model';
import { clientNeedsFullIntakeForm } from '@/shared/lib/utils';

export function AiUnderwritingCtaAlert() {
  const client = useSelector(selectClient);
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!clientNeedsFullIntakeForm(client)) {
    return null;
  }

  return (
    <>
      <Alert
        variant="info"
        className="flex items-center justify-between gap-3 p-3"
      >
        <div className="flex items-center gap-2 pl-0.5">
          <ClipboardCheck className="size-4.5" />
          <AlertDescription className="text-primary-dark text-sm">
            Complete the medical questionnaire to unlock AI underwriting eligibility analysis.
          </AlertDescription>
        </div>
        <Button
          size="sm"
          className="h-7 shrink-0 rounded-sm px-2.5"
          onClick={() => setDialogOpen(true)}
        >
          Run Underwriting Analysis
        </Button>
      </Alert>
      <QuestionnaireDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        variant="underwriting"
      />
    </>
  );
}
